import React, { useState, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import LinksComponent from './Links';
import FindBranches from './FindBranches';
import Leadership from './Leadership';
import { ChevronLeft, ChevronRight, Scale, Landmark, Users } from 'lucide-react';

const IntroductionPage = () => {
  const { language } = useLanguage();
  const [currentSlide, setCurrentSlide] = useState(0);
const [activeNewsIndex, setActiveNewsIndex] = useState(0);

const content = {
  en: {
    title: 'Introduction',
    mainText: 'Tamil Nadu has been a pioneer in India\'s cooperative movement, focusing on serving rural communities. Cooperatives play a crucial role in boosting agricultural productivity and farmers\' incomes by providing timely crop loans, including interest-free loans for prompt repayment, as well as short-term, medium-term, long-term, jewel, and produce pledge loans. They also implement the Crop Insurance Scheme.Cooperatives manage the Public Distribution System through fair price shops and stabilize market prices under the Market Intervention Scheme (MIS) by procuring essential commodities like tur dal, urad dal, chillies, tamarind, gingelly oil, and onions at reasonable rates for sale at cooperative outlets. Additionally, they operate "Farm Fresh" consumer outlets for affordable vegetables and "Amma Marundagam" pharmacies offering discounted quality medicines.',
    readMore: 'Read more',
    whatsNewTitle: "What's New ?",
    newsItems: [
      {
        id: 1,
        title: 'Development of Legal Information System & Technology (LIST) Solution',
        description: 'The Registrar of Cooperative Societies (RCS) is implementing a comprehensive digital transformation initiative. This new system will streamline legal processes, improve case management, and enhance transparency in cooperative governance across Tamil Nadu.',
        date: 'December 5, 2025',
        category: 'Technology'
      },
      {
        id: 2,
        title: 'New Cooperative Banking Initiative Launched',
        description: 'A revolutionary banking scheme has been introduced to provide enhanced financial services to rural cooperatives. This initiative aims to strengthen credit facilities, reduce interest rates for farmers, and improve digital banking infrastructure in cooperative societies.',
        date: 'December 3, 2025',
        category: 'Finance'
      },
      {
        id: 3,
        title: 'Farmer Welfare Scheme Expansion Announced',
        description: 'The cooperative department has announced a major expansion of farmer welfare programs across Tamil Nadu. This includes increased subsidies for agricultural equipment, enhanced crop insurance coverage, and new training initiatives to improve farming techniques and productivity.',
        date: 'December 1, 2025',
        category: 'Agriculture'
      }
    ]
  },
  ta: {
    title: 'அறிமுகம்',
    mainText: 'தமிழ்நாடு இந்தியாவின் கூட்டுறவு இயக்கத்தில் முன்னோடியாக இருந்து வருகிறது, கிராமப்புற சமுதாயங்களுக்கு சேவை செய்வதில் கவனம் செலுத்துகிறது. விவசாயிகளின் உற்பத்தித்திறனை அதிகரிக்கவும், விவசாயிகளின் வருமானத்தை பெருக்கவும் கூட்டுறவு நிறுவனங்கள் முக்கிய பங்கு வகிக்கின்றன. உரிய நேரத்தில் பயிர் கடன்கள், உடனடி திருப்பிச் செலுத்துவதற்கான வட்டியில்லா கடன்கள், குறுகிய கால, நடுத்தர கால, நீண்ட கால, நகை மற்றும் விளைபொருள் அடகு கடன்கள் வழங்குகின்றன. அவர்கள் பயிர் காப்பீட்டு திட்டத்தையும் செயல்படுத்துகின்றனர். கூட்டுறவு நிறுவனங்கள் நியாயமான விலை கடைகள் மூலம் பொதுவிநியோக அமைப்பை நிர்வகிக்கின்றன மற்றும் சந்தை தலையீட்டு திட்டத்தின் (MIS) கீழ் துவரம் பருப்பு, உளுந்தம் பருப்பு, மிளகாய், புளி, நல்லெண்ணெய் மற்றும் வெங்காயம் போன்ற அத்தியாவசிய பொருட்களை நியாயமான விலையில் வாங்கி கூட்டுறவு கடைகளில் விற்பனை செய்வதன் மூலம் சந்தை விலைகளை நிலைப்படுத்துகின்றன. கூடுதலாக, அவர்கள் மலிவு காய்கறிகளுக்கு "பண்ணை புதிய" நுகர்வோர் கடைகள் மற்றும் தரமான மருந்துகள் தள்ளுபடி விலையில் வழங்கும் "அம்மா மருந்தகம்" மருந்தகங்களை இயக்குகின்றனர்.',
    readMore: 'மேலும் படிக்க',
    whatsNewTitle: "புதிதாக என்ன ?",
    newsItems: [
      {
        id: 1,
        title: 'சட்ட தகவல் அமைப்பு மற்றும் தொழில்நுட்ப (LIST) தீர்வின் வளர்ச்சி',
        description: 'கூட்டுறவு சங்கங்களின் பதிவாளர் (RCS) ஒரு விரிவான டிஜிட்டல் மாற்ற முயற்சியை செயல்படுத்துகிறார். இந்த புதிய அமைப்பு சட்ட செயல்முறைகளை எளிதாக்கும், வழக்கு மேலாண்மையை மேம்படுத்தும் மற்றும் தமிழ்நாடு முழுவதும் கூட்டுறவு ஆட்சியில் வெளிப்படைத்தன்மையை மேம்படுத்தும்.',
        date: 'டிசம்பர் 5, 2025',
        category: 'தொழில்நுட்பம்'
      },
      {
        id: 2,
        title: 'புதிய கூட்டுறவு வங்கி முயற்சி தொடங்கப்பட்டது',
        description: 'கிராமப்புற கூட்டுறவு நிறுவனங்களுக்கு மேம்பட்ட நிதி சேவைகளை வழங்க ஒரு புரட்சிகர வங்கி திட்டம் அறிமுகப்படுத்தப்பட்டுள்ளது. இந்த முயற்சி கடன் வசதிகளை வலுப்படுத்துதல், விவசாயிகளுக்கான வட்டி விகிதங்களைக் குறைத்தல் மற்றும் கூட்டுறவு சங்கங்களில் டிஜிட்டல் வங்கி உள்கட்டமைப்பை மேம்படுத்துதல் ஆகியவற்றை நோக்கமாகக் கொண்டுள்ளது.',
        date: 'டிசம்பர் 3, 2025',
        category: 'நிதி'
      },
      {
        id: 3,
        title: 'விவசாயிகள் நல திட்ட விரிவாக்கம் அறிவிக்கப்பட்டது',
        description: 'கூட்டுறவு துறை தமிழ்நாடு முழுவதும் விவசாயிகள் நல திட்டங்களின் பெரிய விரிவாக்கத்தை அறிவித்துள்ளது. இதில் விவசாய உபகரணங்களுக்கான அதிகரித்த மானியங்கள், மேம்படுத்தப்பட்ட பயிர் காப்பீட்டு கவரேஜ் மற்றும் விவசாய நுட்பங்கள் மற்றும் உற்பத்தித்திறனை மேம்படுத்துவதற்கான புதிய பயிற்சி முயற்சிகள் அடங்கும்.',
        date: 'டிசம்பர் 1, 2025',
        category: 'விவசாயம்'
      }
    ]
  }
};

  const t = content[language];

const slides = [
  {
    type: 'youtube',
    videoId: '/Images/WhatsApp Video 2025-12-08 at 2.42.24 PM (1).mp4',
    title: 'Cooperative Department Video'
  },
  {
    type: 'image',
    src: '/Images/SKM_5638.JPG',
    alt: 'Second Slide'
  },
   {
    type: 'youtube',
    videoId: '/Images/WhatsApp Video 2025-12-08 at 2.42.24 PM.mp4',
    title: 'Cooperative Department Video'
  },
   {
    type: 'image',
    src: '/Images/SKM_5638.JPG',
    alt: 'Third Slide'
  },
   {
    type: 'youtube',
    videoId: '/Images/WhatsApp Video 2025-12-08 at 2.42.44 PM.mp4',
    title: 'Cooperative Department Video'
  },
  
  // Add more images or videos as needed
];
const nextSlide = () => {
  setCurrentSlide((prev) => (prev + 1) % slides.length);
};

const prevSlide = () => {
  setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
};
// Auto-rotate news items
useEffect(() => {
  const newsTimer = setInterval(() => {
    setActiveNewsIndex((prev) => (prev + 1) % t.newsItems.length);
  }, 5000); // Change every 5 seconds
  return () => clearInterval(newsTimer);
}, [t.newsItems.length]);
// Auto-rotate media slides
// useEffect(() => {
//   const slideTimer = setInterval(() => {
//     setCurrentSlide((prev) => (prev + 1) % slides.length);
//   }, 5000); // Change every 5 seconds
//   return () => clearInterval(slideTimer);
// }, [slides.length]);
  return (
    <div className="bg-gray-50" style={{ fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif' }}>
      {/* Title Section - Neutral Clean Header */}
      <section className="py-4 sm:py-6 bg-white border-b-2 border-gray-200">
        <div className="container mx-auto px-4"> 
          <div className="text-center">
            <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-800 mb-2 sm:mb-3">
              {t.title}
            </h1>
            <div className="w-16 sm:w-20 h-1 bg-gray-800 mx-auto"></div>
            {/* Introduction Text */}
            <div className="py-4 sm:py-6 px-3 sm:px-4 md:px-8 mt-3 sm:mt-4 bg-gray-50 border border-gray-200">
              <div className="max-w-6xl mx-auto">
                <p className="text-gray-700 leading-relaxed text-xs sm:text-sm md:text-base text-justify">
                  {t.mainText}
                  <button className="text-gray-800 hover:text-black ml-1 font-semibold transition-colors duration-200 underline">
                    {t.readMore}
                  </button>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Content Section - Light Blue Background */}
      <section className="py-6 sm:py-8 overflow-hidden relative" style={{ backgroundColor: '#b6e2eb' }}>
        <div className="absolute inset-0 z-0 opacity-3 pointer-events-none">
          {/* Justice Scale Icon */}
          <div className="absolute top-1/4 left-1/4 text-gray-300 animate-pulse-slow">
            <Scale size={80} className="opacity-20" /> 
          </div>
          
          {/* Users/Community Icon */}
          <div className="absolute bottom-1/4 right-1/4 text-gray-300 animate-float-slow">
            <Users size={100} className="opacity-20" />
          </div>

          {/* Landmark/Government Building Icon */}
          <div className="absolute top-1/2 right-10 text-gray-300 animate-pulse-slow delay-1000"> 
            <Landmark size={60} className="opacity-20" />
          </div>
        </div>
        
        <div className="container mx-auto px-3 sm:px-4 relative z-10"> 
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6 max-w-7xl mx-auto"> 

            {/* Media Carousel Card */}
<div className="bg-white shadow-lg overflow-hidden border border-gray-300">
  <div className="relative group">
    {/* Media Content */}
    <div className="w-full h-64 sm:h-80 bg-gray-200">
      {slides[currentSlide].type === 'image' ? (
        <img
          src={slides[currentSlide].src}
          alt={slides[currentSlide].alt}
          className="w-full h-full object-cover"
        />
      ) : (
      <video
  className="w-full h-full object-cover"
  controls
  autoPlay
  muted
  loop
>
  <source src={slides[currentSlide].videoId} type="video/mp4" />
  Your browser does not support the video tag.
</video>

      )}
    </div>

    {/* Navigation Arrows - Only show if more than 1 slide */}
    {slides.length > 1 && (
      <>
        <button
          onClick={prevSlide}
          className="absolute left-2 sm:left-3 top-1/2 transform -translate-y-1/2 bg-white/90 hover:bg-white text-gray-800 p-1.5 sm:p-2 shadow-md transition-all"
          aria-label="Previous slide"
        >
          <ChevronLeft size={18} className="sm:w-5 sm:h-5" />
        </button>

        <button
          onClick={nextSlide}
          className="absolute right-2 sm:right-3 top-1/2 transform -translate-y-1/2 bg-white/90 hover:bg-white text-gray-800 p-1.5 sm:p-2 shadow-md transition-all"
          aria-label="Next slide"
        >
          <ChevronRight size={18} className="sm:w-5 sm:h-5" />
        </button>
      </>
    )}

    {/* Slide Indicators */}
    {slides.length > 1 && (
      <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex gap-2">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            className={`w-2 h-2 rounded-full transition-all ${
              index === currentSlide
                ? 'bg-white w-6'
                : 'bg-white/50 hover:bg-white/75'
            }`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    )}
  </div>
</div>

     {/* What's New Card - Content Only */}
<div className="bg-white shadow-lg overflow-hidden border border-gray-300">
  {/* Title Section */}
  <div className="text-center py-2 sm:py-3 bg-gray-50 border-b-2 border-gray-300">
    <h3 className="text-xl sm:text-2xl font-bold text-gray-900">
      {t.whatsNewTitle}
    </h3>
    <div className="w-16 sm:w-20 h-1 bg-gray-800 mx-auto mt-1"></div>
  </div>

{/* Vertical Auto-Scroll News Content */}
<div className="p-4 sm:p-5 overflow-hidden h-56 relative">
  <div
    className="absolute w-full"
    style={{
      animation: "vertical-marquee 12s linear infinite"
    }}
  >
    {t.newsItems.map((item, index) => (
      <div key={index} className="mb-8">
        <span className="text-xs font-semibold px-2 py-1 rounded bg-gray-800 text-white">
          {item.category}
        </span>

        <h4 className="font-bold text-gray-900 text-base sm:text-lg mt-3">
          {item.title}
        </h4>

        <p className="text-xs text-gray-500 mt-1">
          {item.date}
        </p>

        <p className="text-gray-600 text-xs sm:text-sm leading-relaxed mt-2">
          {item.description}
        </p>
      </div>
    ))}
  </div>
</div>


</div>
          </div>
        </div>
      </section>

      {/* Leadership Section */}
      <Leadership />

      {/* Map Section */}
      <FindBranches />
      
      {/* Links Section */}
      <LinksComponent />
    </div>
  );
};

export default IntroductionPage;